<template>
  <b-row class='mb-4'>
    <b-col v-for='(locale, i) in locales' :key='i'>
      <label :for="`flatpage${flatPage.id}_title_locale${i}`">Tytuł {{locale}}</label>
      <b-form-input
        :id="`flatpage${flatPage.id}_title_locale${i}`"
        :value='flatPage.title[locale]'
        @input='(e) => actions.handleFlatPageTitleChanged(flatPage.id, e, locale)'
      />
    </b-col>
  </b-row>
</template>

<script>

  import { LOCALES } from '@/utils'
  import {
    handleFlatPageTitleChanged,
  } from '@/store/utils.js'

  export default {
    props: {
      flatPage: {
        type: Object,
      },
    },
    data() {
      return {
        actions: {
          handleFlatPageTitleChanged,
        },
        locales: LOCALES,
        value: this.data,
      }
    },
  }

</script>    